<template>
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show" class="py-0">
                    <v-toolbar class="py-0 my-0" dark color="green">
                        <v-toolbar-title class="my-0 py-0">Carga de Datos - Bienes</v-toolbar-title>

                    </v-toolbar>
                </v-card>
                <v-card color="green lighten-4" class="py-0 my-0">
                    <v-card-text>
                        <v-data-table dense :headers="headers" :items="listadoequipo" locale="es-ar" class="elevation-1"
                            :items-per-page="400" hide-default-footer>

                            <template v-slot:item.actual="{ item }">
                                <div class="right-input">
                                    <v-text-field type="number" dense v-model="item.actual" single-line></v-text-field>
                                </div>
                            </template>
                            <template v-slot:item.tipo="{ item }">
                                <div class="d-flex justify-center">
                                    <v-select dense v-model="item.tipo" :items="listadounidad" item-text="nombre"
                                        item-value="valor"></v-select>
                                </div>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
                <v-card color="green lighten-4" class="py-0 my-0">
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field color="green darken-2" dense v-model="fecha" label="Fecha">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card color="green lighten-4" dark tile>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-app>
    </div>
</template>

<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
export default {
    data: (vm) => ({
        valid: false,
        deshabilitar: false,
        lazy: false,
        fecha: moment().format("DD/MM/YYYY"),
        listadoequipo: [],
        datos: [],
        headers: [
            { text: "Código", value: "codgral", width: "10%", sortable: false },
            { text: "Bien", value: "detalle", width: "50%", sortable: false },
            { text: "Situación Actual", value: "actual", width: "20%", sortable: false },
            { text: "Unidad", value: "tipo", width: "20%", sortable: false },
        ],
        listadounidad: [
            { nombre: "Km", valor: "Km" },
            { nombre: "Horas", valor: "Horas" },
            { nombre: "Meses", valor: "Meses" },
        ],
    }),
    computed: {

        show: {
            get() {
                this.cargarEquipo();
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        vaciarModels() {
            this.listadoequipo = []
        },
        cargarEquipo() {
            let self = this;
            axios
                .get("/SSGG/CargarEquiposManten?", {
                    params: {
                    },
                })
                .then((response) => {
                    self.listadoequipo = response.data;
                })
                .catch((error) => {
                    self.listadoequipo = "";
                    console.log(error);
                });
        },

        guardar() {
            this.$swal({
                title: "Guardar Datos",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.listadoequipo.forEach((element) => {
                        if (element.actual != "" && element.actual != null) {
                            this.datos.push({
                                codgral: element.codgral,
                                fecha: this.fecha,
                                actual: element.actual,
                                tipo: element.tipo,
                            })
                        }
                    })

                    let self = this;
                    axios
                        .post("/SSGG/GuardarDatos", this.datos)
                        .then((response) => {
                            self.$refs.form.resetValidation();
                            self.vaciarModels();
                            self.showAlert({
                                icon: "success",
                                title: "Datos guardados con éxito",
                                vm: self,
                            });
                            self.$emit("close");
                        })
                        .catch({});
                } else {
                }
            });
        },



        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
    }
};
</script>